import { Suspense } from 'react';
import type { ReactElement } from 'react';
import { useSyncPortfolioFilterWithCurrentSubAccounts } from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters';
import { useAccountsSuspenseQuery } from 'generated/graphql';
import NavigableTabs from 'components/technical/NavigableTabs/NavigableTabs.tsx';
import NavigableTab from 'components/technical/NavigableTabs/NavigableTab.tsx';
import Loader from 'components/technical/Loader/Loader.tsx';

const AccountList = (): ReactElement => {
  const { data } = useAccountsSuspenseQuery();
  useSyncPortfolioFilterWithCurrentSubAccounts(data.portfolio.accounts.flatMap((a) => a.subAccounts));

  return (
    <NavigableTabs fullHeight>
      <NavigableTab link="/app/management/account/cex" text="CEXs/Custodians" />
      <NavigableTab link="/app/management/account/blockchain" text="Blockchain wallets" />
      <NavigableTab link="/app/management/account/manual" text="Manual" />
      <NavigableTab link="/app/management/account/non-crypto" text="TradFi integrations" />
    </NavigableTabs>
  );
};

const AccountListContainer = (): ReactElement => {
  return (
    <Suspense fallback={<Loader />}>
      <AccountList />
    </Suspense>
  );
};

export default AccountListContainer;
